<template>
  <v-flex style="overflow-x:auto">
    <table id="permissions-table">
      <thead>
        <tr>
          <th v-for="(fieldset, index) in fieldsets" :key="index" class="text-truncate permission-label"><div>{{fieldset.name}}</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(team, teamNo) in teams" :key="teamNo">
          <slot v-for="(fieldset, index) in fieldsets">
            <td v-if="isReadPermission(getState(team, fieldset.id))" @click="toggleState(team, fieldset)" class="permission-check" :key="index"> <v-icon class="letter" style="width:30px;" color="green">R</v-icon> </td>
            <td v-if="isWritePermission(getState(team, fieldset.id))" @click="toggleState(team, fieldset)" class="permission-check" :key="index"> <v-icon class="letter" style="width:30px;" color="red">W</v-icon> </td>
            <td v-if="isNullPermission(getState(team, fieldset.id))" @click="toggleState(team, fieldset)" class="permission-check" :key="index"> <v-icon class="letter" style="width:30px;">-</v-icon></td>
          </slot>
        </tr>
      </tbody>
    </table>
  </v-flex>
</template>

<script>

export const PermissionTypes = {
  READ: 'r',
  WRITE: 'w',
  NULL: ''
}
export default {
  name: "CaseConfigPermissionFieldsets",
  props: { caseType: { type: Object, required: true }, teams: { type: Array, required: true } },
  computed: {
    data() {
      if (this.caseType) {
        return {
          caseTypeId: this.caseType.id,
          permissions: this.caseType.permissions,
          resources: this.caseType.resources,
          accessTeams: this.caseType.teams,
          tasklists: this.caseType.tasklistTemplates
        }
      }
      return undefined
    },
    resourceIds() {
      const resourceIds = []
      if (this.data.resources) {
        this.data.resources.forEach(function(res) {
          if (res) {
            if (res.permissionType === "read_write_hidden" && res.resourceType === "case") {
              resourceIds.push(res.id)
            }
          }
        })
      }
      return resourceIds
    },
    fieldsets() {
      const fieldsets = []
      if (this.data.resources) {
        this.data.resources.forEach(function(res) {
          if (res) {
            if (res.permissionType === "read_write_hidden" && res.resourceType === "case") {
              fieldsets.push(res)
            }
          }
        })
      }
      return fieldsets
    },
    permissions() {
      const permissions = []
      if (this.data.permissions) {
        this.data.permissions.forEach(function(perm) {
          if (perm) {
            if (this.resourceIds.includes(perm.resource.id)) {
              permissions.push(perm)
            }
          }
        })
      }
      return permissions
    }
  },
  methods: {
    getState(team, resourceId) {
      const permission = this.data.permissions.find((currentPermission) => (currentPermission.team.id === team.id && currentPermission.resource.id === resourceId))
      if (permission) {
        return permission.permissionFlag
      } else {
        return ""
      }
    },
    isReadPermission(permission) { return permission === PermissionTypes.READ },
    isWritePermission(permission) { return permission === PermissionTypes.WRITE },
    isNullPermission(permission) { return permission === PermissionTypes.NULL },
    async toggleState(team, fieldset) {
      const permission = this.data.permissions.find((currentPermission) => (currentPermission.team.id === team.id && currentPermission.resource.name === fieldset.name))

      if (permission) {
        switch (permission.permissionFlag) {
          case "r":
            await this.deletePermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, fieldset: fieldset })
            await this.createPermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, fieldset: fieldset, readOrWrite: "WRITE" })
            break
          case "w":
            await this.deletePermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, fieldset: fieldset })
            break
          default:
            await this.createPermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, fieldset: fieldset, readOrWrite: "READ" })
        }
      } else {
        await this.createPermission({ caseTypeId: this.data.caseTypeId, teamId: team.id, fieldset: fieldset, readOrWrite: "READ" })
      }
    },
    async createPermission(permData) {
      const newPermission = await this.$store.dispatch("grantFieldsetPermission", permData)
      if (newPermission && !newPermission.error) { this.data.permissions.push(newPermission) }
    },
    async deletePermission(permData) {
      const response = await this.$store.dispatch("revokeFieldsetPermission", permData)
      if (response && !response.error) {
        const permission = this.data.permissions.find((currentPermission) => (currentPermission.team.id === permData.teamId && currentPermission.resource.name === permData.fieldset.name))
        const index = this.data.permissions.indexOf(permission)
        if (index >= 0) this.data.permissions.splice(index, 1)
      }
    }
  }
}
</script>
